import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { ReactNode, MouseEventHandler } from 'react'

export const Button = observer(
    ({
        active,
        onClick,
        children,
    }: {
        active?: boolean
        onClick: MouseEventHandler<HTMLButtonElement>
        children: ReactNode
    }) => {
        return (
            <button
                className={classNames(
                    'size-10 appearance-none rounded-full p-1.5 text-neutral-400 hover:bg-neutral-700 active:bg-neutral-600 [&>svg]:fill-current',
                    {
                        'bg-neutral-600 text-white': active,
                    }
                )}
                onClick={onClick}
            >
                {children}
            </button>
        )
    }
)
